import { createContext, Dispatch, SetStateAction } from 'react';
import { FormInstance } from 'antd';

import { AdditionalDataSectionForm, ClientDataSectionForm, PaymentMethodSectionForm } from './StepFourFormProvider';
import { CreditCardsInsured } from '../../../../../../../../shared/interfaces';
import { TransferRightsFormData } from '../../../../../../../../shared/interfaces/services/transfer-rights-service';

interface StepFourFormContextProps {
  additionalDataFormValues:           AdditionalDataSectionForm | undefined;    
  setAdditionalDataFormValues:        Dispatch<SetStateAction<AdditionalDataSectionForm | undefined>>;

  additionalDataSectionForm:          FormInstance<AdditionalDataSectionForm>;

  errorCreditCardMessage:             string;
  setErrorCreditCardMessage:          Dispatch<SetStateAction<string>>;

  listCreditCardInsured:              CreditCardsInsured | undefined;
  setListCreditCardInsured:           Dispatch<SetStateAction<CreditCardsInsured | undefined>>;

  methodSelectedFromStepThree:        any;
  setMethodSelectedFromStepThree:     Dispatch<SetStateAction<any>>;

  paymentMethodFormValues:            PaymentMethodSectionForm | undefined;
  setPaymentMethodFormValues:         Dispatch< SetStateAction<PaymentMethodSectionForm | undefined>>;

  paymentMethodSectionForm:           FormInstance<PaymentMethodSectionForm>;

  propertyDataForm:                   FormInstance<any>;

  validitySectionForm:                FormInstance<{ validityDate: any }>;

  setTransferRightsList:              Dispatch<SetStateAction<TransferRightsFormData[]>>;
  transferRightsList:                 TransferRightsFormData[];
}

export const StepFourFormContext = createContext(
  {} as StepFourFormContextProps
);
